import React from 'react';
import { useLocalStorageState } from 'ahooks';
import { AccountPersistInfo } from 'Internal.CommonAPI';
import {
  useDatevAuthentication,
  useRedirectParameters,
} from 'Datev/hooks/settings';
import { DatevSettings } from 'utils/apiClient/services/datev/types';
import SetupView from 'Datev/components/views/SetupView';

const Setup: React.FC = () => {
  const [account] = useLocalStorageState<AccountPersistInfo>('account');

  const authQuery = useDatevAuthentication(
    account !== undefined && account.hasDatevSub
  );

  const redirectParamsQuery = useRedirectParameters();

  if (account !== undefined) {
    return (
      <SetupView
        isLoading={authQuery.isLoading}
        hasDatevSub={account.hasDatevSub}
        isAuthenticated={authQuery.data?.has_token!}
        datevSettings={redirectParamsQuery.data! as DatevSettings}
        hasTenant={authQuery.data?.has_tenant!}
        serverError={authQuery.error as unknown as string}
      />
    );
  }
  return null;
};

export default Setup;
